var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.href,"data-e2e":`${_vm.affiliateId}-affiliate-link`},on:{"click":_vm.trackAndGo}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(`Go to ${_vm.affiliateId}`)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }